import React from 'react';
import Header from "../components/header/Header";
import HomePage from "./HomePage";
import Footer from "../components/footer/Footer";

const HomeRoute = () => {
    return (
        <div className="home-page-route">
            <Header/>
            <HomePage/>
            <Footer/>
        </div>
    );
};

export default HomeRoute;
